import { Option } from "@interfaces/option";
import { createActionGroup, props } from "@ngrx/store";

export const IbgeActions = createActionGroup({
  source: "Ibge",
  events: {
    "Load States": props<{
      states: Option[];
    }>(),
    "Load Cities": props<{
      cities: Option<string | number>[];
      cacheKey: string;
    }>()
  }
});
